import { render, staticRenderFns } from "./FullCalendar.vue?vue&type=template&id=5730c2d9&"
import script from "./FullCalendar.vue?vue&type=script&lang=ts&"
export * from "./FullCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports